export enum TripStatus {
  LEG_STARTED = 'Leg Started',
  LEG_COMPLETED = 'Leg Completed',
  LEG_REVERTED = 'Leg Reverted',
  TRIP_ASSIGNED = 'Trip Assigned',
  TRIP_ASSIGNMENT_UPDATED = 'Trip Assignment Updated',
  TRIP_COMPLETED = 'Trip Completed',
  TRIP_UPDATED = 'Trip Updated',
  TRIP_CREATED = 'Trip Created',
  TRIP_ACCEPTED = 'Trip Accepted',
  TRIP_STARTED = 'Trip Started',
}

export enum LeadStatus {
  NEW = 1,
  PENDING = 2,
  IN_PROGRESS = 3,
  AUDITED = 4,
  VALIDATED = 5,
  CONFIRMED = 6,
  COMPLETED = 7,
  REJECTED = 8,
  DONE = 9
}

export const STATUS_MAP: { [key: number]: string } = {
  [LeadStatus.NEW]: 'New',
  [LeadStatus.PENDING]: 'Pending',
  [LeadStatus.IN_PROGRESS]: 'In Progress',
  [LeadStatus.AUDITED]: 'Audited',
  [LeadStatus.VALIDATED]: 'Validated',
  [LeadStatus.CONFIRMED]: 'Confirmed',
  [LeadStatus.COMPLETED]: 'Completed',
  [LeadStatus.REJECTED]: 'Rejected',
  [LeadStatus.DONE]: 'Done'
};